import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import PageLayout from '../../components/PageLayout.vue';
import JsonCode from '../../components/jwt.vue';
export default {
  __name: 'JwtPage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PageLayout, {
        title: "JWT加密/解密",
        "current-page": "url"
      }, {
        default: _withCtx(() => [_createVNode(JsonCode)]),
        _: 1
      });
    };
  }
};